import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { RaisonImmobilisation } from './raison-immobilisation.model';
import { ImmobilisationDemandeClientService } from '../../../../core/services/immobilisation-demande-client.service';
import { InlineResponse } from '../../../../core/models/inline-response.model';
import { LieuImmobilisation } from './lieu-immobilisation.model';

@Injectable({
  providedIn: 'root',
})
export class ReferentialsImmobilisationDemandeService {
  constructor(private immobilisationDemandeClientService: ImmobilisationDemandeClientService) {}

  getRaisonImmobilisation(): Observable<RaisonImmobilisation[]> {
    return this.immobilisationDemandeClientService.getAllRaisonImmobilisation().pipe(
      map((raison) => raison.rows),
      map((rows) => rows.map((row) => new RaisonImmobilisation(row.id, row.raison))),
    );
  }

  addRaisonImmobilisation(raison: string): Observable<InlineResponse> {
    return this.immobilisationDemandeClientService.addRaisonImmobilisation(raison);
  }

  updateRaisonImmobilisation(raisonImmobilisation: RaisonImmobilisation): Observable<InlineResponse> {
    return this.immobilisationDemandeClientService.updateRaisonImmobilisation(raisonImmobilisation);
  }

  getLieuImmobilisation(): Observable<LieuImmobilisation[]> {
    return this.immobilisationDemandeClientService.getAllLieuImmobilisation().pipe(
      map((lieu) => lieu.rows),
      map((rows) => rows.map((row) => new LieuImmobilisation(row.id, row.lieu))),
    );
  }

  addLieuImmobilisation(lieu: string): Observable<InlineResponse> {
    return this.immobilisationDemandeClientService.addLieuImmobilisation(lieu);
  }

  updateLieuImmobilisation(lieuImmobilisation: LieuImmobilisation): Observable<InlineResponse> {
    return this.immobilisationDemandeClientService.updateLieuImmobilisation(lieuImmobilisation);
  }
}
